export const BENEFITS_TOP_BLOCK_DATA = (images: TImages) => [
  {
    img: images['benefits'],
    title: 'Развиваем профессионализм',
    body:
      'Грейды, карьерный трек, обучение и технологизации для роста сотрудников',
  },
  {
    img: images['benefits2'],
    title: 'Воплощаем идеи в реальность',
    body:
      'KODE даёт возможность запускать стартапы, открывать подразделения и строить эффективные процессы',
  },
  {
    img: images['benefits3'],
    title: 'Заботимся о здоровье',
    body: 'ДМС, компенсация тренировок, походы и путешествия',
  },
]
